import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import { getExtras, getProductData } from "../../../utils/getUserUtility";
import handleErrorLandings from "../handleErrorLandings";
import ErrorPause from "./ErrorPause";

const landingId = "CF_ERROR_PAUSE";

const onLoad = async ({ session, landedAt, uid, navigate }) => {
  try {
    const prevAnswers = {};
    const prevForm = await getFormSession(
      "cancelation-form",
      session.sessionID
    );
    const landings = prevForm.items;
    landings.forEach((item) => {
      if (item.answers.length > 0) {
        const lastField = item?.answers[0];
        const fieldID = lastField.field.id;
        const lastFieldType = lastField.type;
        const lastFieldAnswers = lastField[lastFieldType]?.value;
        prevAnswers[fieldID] = lastFieldAnswers;
      }
    });
    const { claimRate } = prevForm.metadata;

    const productsToCancel = landings[0];
    const productsField = productsToCancel.answers[0];
    const productType = productsField.type;
    const products = productsField[productType].value;
    const product = products[0];
    const discount = Math.min(0.2, Math.abs(0.6 - claimRate));
    const productData = await getProductData(uid, product);
    const extras = await getExtras(uid, product.id);
  
    const extrasPremium = extras.reduce(
      (sum, extra) =>
        sum +
        extra.premium *
          (extra?.items && extra.items[0]?.quantity
            ? extra.items[0].quantity
            : 1),
      0
    );


    const total = productData.premium + extrasPremium
    const totalWithDiscount = Math.ceil(total - (total * discount))

    const periods = {
      month: "mensual",
      "3month": "trimestral",
      "6month": "semestral",
      year: "anual",
    };
    
    console.log("->", {
      claimRate,
      prima: productData.premium,
      periodo: periods[productData.period],
      descuento: discount,
      primaConDescuento: totalWithDiscount,
    });

    return {
      userId: uid,
      pid: product.id,
      sessionID: session.sessionID,
      pType: product.type,
      ...prevAnswers,
      landedAt,
      prevForm,
      currentLanding: landingId,
      premium: productData.premium + extrasPremium,
      discount: discount * 100,
      premiumWithDiscount: totalWithDiscount,
      period: periods[productData.period],
    };
  } catch (error) {
    await handleErrorLandings({
      error,
      landingId,
      navigate,
      navigatePath: `/formulario/cancelacion/lealtad?uid=${uid}`,
      message: `[Error Ofrecer Descuento][OFFER_DISCOUNT] Ocurrio un error al pedir la información\nlandingError: ${landingId}\nUID: ${uid}\nSessionID: ${session.sessionID}`,
    });
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <ErrorPause state={state} setState={setState} />
);

const nextPage = async (props) => {};
const prevPage = (props) =>{};

const fieldsStructure = [];

const errorPauseProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default errorPauseProps;
